import React, { useState } from 'react';

function StepTen({ formData, onNext,  }) {
    const [signature, setSignature] = useState(formData.declareSignature || '');
    const [date, setDate] = useState(formData.declareDate || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!signature.trim() || !date.trim()) {
            setError('Please provide your signature and date.');
            return;
        }

        setError('');
        onNext({ declareSignature:signature, declareDate:date });
    };

    const isFormValid = signature.trim() && date.trim();

    return (
        <div className="step-form">
            <h6 className="mb-4">Declaration</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p className="mb-4">
                I declare that the information I have provided is true and complete to the best of my knowledge.
            </p>

            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-4 dec_label">
                        <label className="form-label">Signature:</label>
                        <input
                            type="text"
                            className="form-control border-0 border-bottom rounded-0"
                            value={signature}
                            onChange={e => setSignature(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-4 dec_label">
                        <label className="form-label">Date:</label>
                        <input
                            type="date"
                            className="form-control border-0 border-bottom rounded-0"
                            value={date}
                            onChange={e => setDate(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepTen;
